/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MobileDeviceScanVM { 
    scanType?: string | null;
    latitude?: number;
    longitude?: number;
    scanSource?: string | null;
    userId?: number | null;
    status?: string | null;
    deviceId?: number | null;
    deviceUUID?: string | null;
    createdAt?: string | null;
    deviceName?: string | null;
    schoolName?: string | null;
    scanDate?: string | null;
}

